import { IAction } from "redux/store/model";

import {
  IFetchAvailableSkusSuccessAction,
  IFetchAvailableStoragesSuccessAction,
} from "./actionCreators";
import * as types from "./actionTypes";
import { IAvailableSku, IStorage } from "./api";
import initialState from "./initialState";

export interface IStoragesState {
  storages: IStorage[];
  isFetchingStorages: boolean;
  hasFetchedStorages: boolean;

  availableSkus: IAvailableSku[];
  isFetchingSkus: boolean;
  currentSourceStorageId: string | null;
}

export default function reducer(
  state = initialState,
  action: IAction,
): IStoragesState {
  switch (action.type) {
    case types.FETCH_AVAILABLE_STORAGES_BEGIN:
      return { ...state, isFetchingStorages: true };

    case types.FETCH_AVAILABLE_STORAGES_SUCCESS: {
      const { storages } = action as IFetchAvailableStoragesSuccessAction;
      return {
        ...state,
        storages,
        isFetchingStorages: false,
        hasFetchedStorages: true,
      };
    }

    case types.FETCH_AVAILABLE_STORAGES_FAILURE:
      return { ...state, isFetchingStorages: false, hasFetchedStorages: true };

    case types.FETCH_AVAILABLE_SKUS_BEGIN:
      return {
        ...state,
        isFetchingSkus: true,
        currentSourceStorageId:
          (action as IAction & { storageId: string }).storageId ?? null,
      };

    case types.FETCH_AVAILABLE_SKUS_SUCCESS: {
      const { skus, storageId } = action as IFetchAvailableSkusSuccessAction;
      // Discard stale responses if the user has changed source in the meantime.
      if (storageId !== state.currentSourceStorageId) {
        return { ...state, isFetchingSkus: false };
      }
      return {
        ...state,
        availableSkus: skus,
        isFetchingSkus: false,
      };
    }

    case types.FETCH_AVAILABLE_SKUS_FAILURE:
      return { ...state, isFetchingSkus: false };

    case types.RESET_AVAILABLE_SKUS:
      return {
        ...state,
        availableSkus: [],
        currentSourceStorageId: null,
        isFetchingSkus: false,
      };

    default:
      return state;
  }
}
